import * as React from "react";
import Filters from "../../components/Filters";
import Loading from "../../components/Loading";
import SelectedFilters from "../../components/SelectedFilters";
import DashboardTitle from "../../components/DashboardTitle";
import BackButton from "../../components/BackButton";
import * as CONST from "../../constants";
import * as API from "../../apis";
import Donut from "../../components/Donut";
import { withStyles } from "@material-ui/core/styles";
import { Chart, Line } from "react-chartjs-2";
import { Grid, Card, Box, Link, IconButton, FormHelperText } from "@material-ui/core";
import { Bar } from "react-chartjs-2";
import CompositeIcon from "@material-ui/icons/BarChartRounded";
import ReactToPrint from "react-to-print";
import PrintIcon from "@material-ui/icons/Print";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";

interface PhoneCallReportsProps {
  state: any;
  dispatch: (param: any) => void;
}

const StyledSwitch = withStyles({
  switchBase: {
    color: "#041353",
    "&$checked": {
      color: "#2cb5fa",
    },
    "&$checked + $track": {
      backgroundColor: "#2cb5fa",
    },
  },
  checked: {},
  track: {},
})(Switch);

const PhoneCallReports: React.FC<PhoneCallReportsProps> = ({ state, dispatch }) => {
  const [loading, setLoading] = React.useState(true);
  const componentRef = React.useRef<HTMLElement | null>(null);
  const healthPlans = CONST.HEALTH_PLANS;
  const [interval, setInterval] = React.useState<string>('weekly');
  const [healthPlan, setHealthPlan] = React.useState<string>(state.filters.health_plan || 'All');
  const [togglePcpComposites, setTogglePcpComposites] = React.useState(false);
  const options = CONST.DEFAULT_TIMELINEGRAPH_OPTIONS;
  let dateIntervalLabels: string[] = [];
  let dateIntervals: string[] = [];

  let answeredData, voicemailsData, abandonedMetTarget;

  function extractMonthlyValuesFromData(data, healthPlanKey, key) {
    return Object.values(
        data.reduce((acc: any, el: any) => {
          const monthStart = el[healthPlan]['Month']["Month start"];
          if (!monthStart) return acc;

          // keep the first occurrence per month
          if (!acc[monthStart] || (acc[monthStart] && acc[monthStart] <  el[healthPlan]['Month'][key])) {
            acc[monthStart] = el[healthPlan]['Month'][key];
          }

          return acc;
        }, {})
      );
  }

  let totalCalls, answeredCalls, abandonedCalls, voicemails, metResponseTimeAbandoned, metResponseTimeVoicemails;
  if (state.phone_call_reports && state.phone_call_reports.data) {
    dateIntervals = state.phone_call_reports.data.map(el => {
      return interval == 'weekly' ? el['Week start'] : el[healthPlan] && el[healthPlan]['Month'] && el[healthPlan]['Month']['Month start'];
    });
    dateIntervalLabels = [...new Set(dateIntervals)];

    if (interval == 'weekly') {
      answeredData = state.phone_call_reports.data.map((el: any) => {
        return el[healthPlan] && el[healthPlan]['Answered %'];
      });
      abandonedMetTarget = state.phone_call_reports.data.map((el: any) => {
        return el[healthPlan] && el[healthPlan]['Met Response Time Target % (Abandoned)'];
      });
      voicemailsData = state.phone_call_reports.data.map((el: any) => {
        return el[healthPlan] && el[healthPlan]['Met Response Time Target % (Voicemails)'];
      });
      totalCalls = state.phone_call_reports.data[state.phone_call_reports.data.length - 1][healthPlan]['Total Calls'];
      answeredCalls = state.phone_call_reports.data[state.phone_call_reports.data.length - 1][healthPlan]['Answered Calls'];
      abandonedCalls = state.phone_call_reports.data[state.phone_call_reports.data.length - 1][healthPlan]['Abandoned Calls'];
      voicemails = state.phone_call_reports.data[state.phone_call_reports.data.length - 1][healthPlan]['Voicemails'];
      metResponseTimeAbandoned = state.phone_call_reports.data[state.phone_call_reports.data.length - 1][healthPlan]['Met Response Time Target (Abandoned)'];
      metResponseTimeVoicemails = state.phone_call_reports.data[state.phone_call_reports.data.length - 1][healthPlan]['Met Response Time Target (Voicemails)'];
    } else {
      voicemailsData = extractMonthlyValuesFromData(state.phone_call_reports.data, healthPlan, 'Met Response Time Target % (Voicemails)');
      abandonedMetTarget = extractMonthlyValuesFromData(state.phone_call_reports.data, healthPlan, 'Met Response Time Target % (Abandoned)');
      answeredData = extractMonthlyValuesFromData(state.phone_call_reports.data, healthPlan, 'Answered %');
      totalCalls = state.phone_call_reports.data[state.phone_call_reports.data.length - 1][healthPlan]['Month']['Total Calls'];
      answeredCalls = state.phone_call_reports.data[state.phone_call_reports.data.length - 1][healthPlan]['Month']['Answered Calls'];
      abandonedCalls = state.phone_call_reports.data[state.phone_call_reports.data.length - 1][healthPlan]['Month']['Abandoned Calls'];
      voicemails = state.phone_call_reports.data[state.phone_call_reports.data.length - 1][healthPlan]['Month']['Voicemails'];
      metResponseTimeAbandoned = state.phone_call_reports.data[state.phone_call_reports.data.length - 1][healthPlan]['Month']['Met Response Time Target (Abandoned)'];
      metResponseTimeVoicemails = state.phone_call_reports.data[state.phone_call_reports.data.length - 1][healthPlan]['Month']['Met Response Time Target (Voicemails)'];
    }
  }
  const data3 = {
    labels: [...dateIntervalLabels],
    datasets: [
      {
        label: "Met Response Time Target (Abandoned)",
        data:  abandonedMetTarget,
        fill: false,
        backgroundColor: CONST.COHORT_2_COLOR,
        hoverBorderColor: CONST.TARGET_GREEN,
        hoverBorderWidth: 3,
        borderColor: "#62717a91",
      }
    ]
  }
  const data2 = {
    labels: [...dateIntervalLabels],
    datasets: [
      {
        label: "Met Response Time Target (Voicemails)",
        data:  voicemailsData,
        fill: false,
        backgroundColor: CONST.COHORT_2_COLOR,
        hoverBorderColor: CONST.TARGET_GREEN,
        hoverBorderWidth: 3,
        borderColor: "#62717a91",
      },
    ]
  };
  const data1 = {
    labels: [...dateIntervalLabels],
    datasets: [
      {
        label: "Answered Percentage (results over time)",
        data:  answeredData,
        fill: false,
        backgroundColor: CONST.COHORT_1_COLOR,
        hoverBorderColor: CONST.TARGET_GREEN,
        hoverBorderWidth: 3,
        borderColor: "#02265db8",
      }
    ]
  };

  const getPhoneCallReports = async ({ ...params }) => {
    const weekly = await API.fetchPhoneCallReports({
      interval: 'weekly',
      ...params
    });
    return weekly;
  };

  React.useEffect(() => {
    (async () => {
      setLoading(true);
      const queryParams = {
        token: state.user.token,
        health_plan: state.user.type == "HealthPlan" ? state.user.id : CONST.HEALTH_PLANS[0],
        interval: 'weekly'
      };
      dispatch({ type: "set_current_filters", payload: queryParams });
      const data = await getPhoneCallReports({ ...queryParams });
      dispatch({
        type: "set_phone_call_reports",
        payload: data,
      });
      setTimeout(() => {
        setLoading(false);
      }, 900);
    })();
  }, []);
  return (
    <>
      {loading && <Loading msg={state.error ? state.error : CONST.MSG_FETCHING_DATA} />}
      {!loading && (
        <Card ref={componentRef} id="card">
          <BackButton token={state.user.token} />
          <DashboardTitle title="Phone Calls" view="qm" />
          <Grid container justify="space-around" alignItems="flex-start">
            <Grid item xs={12}>
              <Grid container spacing={1} justify="center" alignItems="center">
                <Grid item justify="center" xs={12} md={8}>
                  <Box>
                    <label>Health Plan: </label>
                    <label>
                      <select
                        className="default"
                        value={healthPlan}
                        onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                          setHealthPlan(e.target.value);
                        }}
                      >
                        {['All', 'All Health Plans', 'NVE', 'Wynn', 'RWLV', 'GMG'].map((option) => (
                          <option value={option} key={option}>
                            {option}
                          </option>
                        ))}
                      </select>
                    </label>
                  </Box>
                  <Box>
                    <label>Interval: </label>
                    <label>
                      <select
                        className="default"
                        value={interval}
                        onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                          setInterval(e.target.value);
                        }}
                      >
                        <option value={'weekly'}>Weekly</option>
                        <option value={'monthly'}>Monthly</option>
                      </select>
                    </label>
                  </Box>
                </Grid>
              </Grid>

              <ReactToPrint
                trigger={() => (
                  <IconButton id="print-btn">
                    Print Report
                    <PrintIcon id="print-icon" />
                  </IconButton>
                )}
                content={() => componentRef.current}
              />
            </Grid>

            <Grid container spacing={0} justify="space-around" alignItems="center">
              <Grid item xs={12}>
                <div id="big">
                  <CompositeIcon id="composite-icon" />
                  Phone Calls KPI
                </div>
                <p id="composite-copy">{CONST.PHONE_CALLS_REPORTS_COPY}</p>
              </Grid>
              <Donut
                color={CONST.COHORT_1_COLOR}
                data={answeredCalls/totalCalls}
                name={`
                  Answered Calls %
                  (${ answeredCalls } of ${ totalCalls } calls)
                `}
              />
              <Donut
                color={CONST.COHORT_1_COLOR}
                data={metResponseTimeAbandoned/abandonedCalls}
                name={`
                  Met Response Time Target % - Abandoned calls
                  (${ metResponseTimeAbandoned } of ${ abandonedCalls } calls)
                `}
              />
              <Donut
                color={CONST.COHORT_1_COLOR}
                data={metResponseTimeVoicemails/voicemails}
                name={`
                  Met Response Time Target % - Voicemails
                  (${ metResponseTimeVoicemails } of ${ voicemails } calls)
                `}
              />
            </Grid>
            <Grid container spacing={0} justify="space-around" alignItems="center">
              <Grid item xs={12} md={4}>
                <>
                  <Box id="graph-box">
                    <label id="graph-box-label">Answered Percentage (results over time)</label>
                  </Box>
                  <Line type="line" id="line-graph" width={9} height={5} options={options} data={data1} />
                </>
              </Grid>
              <Grid item xs={12} md={4}>
                <>
                  <Box id="graph-box">
                    <label id="graph-box-label">Met Response Time Target (Abandoned)</label>
                  </Box>
                  <Line type="line" id="line-graph" width={9} height={5} options={options} data={data3} />
                </>
              </Grid>
              <Grid item xs={12} md={4}>
                <>
                  <Box id="graph-box">
                    <label id="graph-box-label">Met Response Time Target (Voicemails)</label>
                  </Box>
                  <Line type="line" id="line-graph" width={9} height={5} options={options} data={data2} />
                </>
              </Grid>
            </Grid>
          </Grid>
        </Card>
      )}
    </>
  );
};

const styles = {
  filterMessage: {
    color: "#8e98a8",
  },
  establishedCaption: {
    textAlign: "center",
    color: "#8e98a8",
    letterSpacing: "0.03em",
    margin: "-.5rem auto 1rem",
    paddingBottom: "1rem",
  },
  switchText: {
    textTransform: "capitalize",
  },
  switch: {
    display: "inline-block",
    marginTop: "-1rem",
  },
} as const;

export default PhoneCallReports;
